import { Sign } from "@/modules/gateway/features/open-external-sign/ui/sign-button/sign";
import Button from "@/shared/form/button";
import { SignatureOutlined } from "@ant-design/icons";
import { Modal, useModal } from "@/shared/modal";
import { useTranslations } from "use-intl";
import {
  SignRegistrationForExternalSignPageFragment,
  SignStatus,
} from "gql/graphql";
import { useExternalSignRegistrationSignedSubscription } from "@/modules/gateway/features/open-external-sign/model/use-external-sign-registration-signed-subscription";
import { useCode } from "@/modules/gateway/features/open-external-sign/model/use-code";

export function SignButtonInModal({
  signRegistration,
}: {
  signRegistration: SignRegistrationForExternalSignPageFragment;
}) {
  const t = useTranslations("Signing");
  const { openModal, open, close } = useModal();
  const { code } = useCode();
  const { signStatus, loading } = useExternalSignRegistrationSignedSubscription(
    {
      code,
    },
  );

  const isSigned = signStatus === SignStatus.Signed;

  return (
    <>
      <Button
        type={"primary"}
        icon={<SignatureOutlined />}
        success
        onClick={open}
        disabled={isSigned || loading}
        loading={loading}
      >
        {t("Sign")}
      </Button>

      <Modal
        open={openModal}
        onCancel={close}
        title={t("Sign with EDS")}
        width={600}
      >
        <div className={"flex justify-center"}>
          <Sign
            signRegistration={signRegistration}
            signStatus={signStatus ?? SignStatus.Pending}
          />
        </div>
      </Modal>
    </>
  );
}
